import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/i18n'
import '@/styles/global.css'
import App from '@/app'
import { Analytics } from '@vercel/analytics/react'
import { redirectLegacyHash } from '@/lib/navigation'

redirectLegacyHash()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Analytics />
    <App />
  </StrictMode>,
)
